// extracted by mini-css-extract-plugin
export default {"description":"style_description__cLksY","fade-in":"style_fade-in__RtSod","top":"style_top__AKp85","image":"style_image__gW9Aq"};